module.exports = __webpack_public_path__ + "img/Telescope.64727f4f.svg";